// extracted by mini-css-extract-plugin
export default {"headerWrap":"index_headerWrap_ltpsP","footerWrap":"index_footerWrap_6Iw0a","subNav":"index_subNav_0zJUH","pageBox":"index_pageBox_dt-Mw"};